import { Container, Row, Col, Modal, Button, Form } from "react-bootstrap";
import { FaEdit, FaDownload } from "react-icons/fa";
import * as XLSX from "xlsx";
import { useNavigate } from "react-router-dom";
import "./Customer.css";
import axios from "axios";
import Swal from "sweetalert2";
import Topbar from "../Topbar/Topbar";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { useSelector } from "react-redux";
import React, { useState, useEffect, useRef } from "react";

export default function Customer({ customerid, onDeleteSuccess }) {
  const permissions = useSelector((state) => state.permissions);
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const navi = useNavigate();
  const [data, setData] = useState([]);

  // ── Completed Installation Customers ──
  const [installCompletedCustomers, setInstallCompletedCustomers] = useState([]);
  const [installFilters, setInstallFilters] = useState({
    customerId: "",
    installcustomerName: "",
    accountStatus: "",
    installcontactNum: "",
    installalternateNum: "",
    installemailId: "",
    installleadSource: "",
    installaddress: "",
    installplanSpeed: "",
    installplanAmount: "",
    installplanMonth: "",
    createdDate: "",
  });

  const [statusCounts, setStatusCounts] = useState({
    active: 0,
    expired: 0,
    suspended: 0,
    disabled: 0,
    online: 0,
    offline: 0,
  });

  const [columnVisibility, setColumnVisibility] = useState({
    customerId: true,
    installcustomerName: true,
    accountStatus: true,
    installcontactNum: true,
    installalternateNum: true,
    installemailId: true,
    installleadSource: true,
    installaddress: true,
    installplanSpeed: true,
    installplanAmount: true,
    installplanMonth: true,
    createdDate: true,
    activationDate: true,
    expiryDate: true,
    actions: true,
  });

  // ── Edit Modal State ──
  const [showEditModal, setShowEditModal] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [editFormData, setEditFormData] = useState({
    installcustomerName: "",
    installcontactNum: "",
    installalternateNum: "",
    installemailId: "",
    installaddress: "",
    accountStatus: "",
  });

  const [addFormData, setAddFormData] = useState({
    installcustomerName: "",
    installcontactNum: "",
    installalternateNum: "",
    installemailId: "",
    installaddress: "",
    installleadSource: "Manual Entry",
    accountStatus: "Active",
    installplanDetails: {
      installplanSpeed: "",
      installplanAmount: "",
      installplanMonth: "",
    },
    createdDate: new Date().toISOString().split("T")[0],
    activationDate: new Date().toISOString().split("T")[0],
  });

  const fileInputRef = useRef(null);

  const fetchCompletedCustomers = () => {
    axios
      .get(apiUrl + "completed-customers")
      .then((res) => {
        if (res.data.success) {
          const customers = res.data.message || [];
          setInstallCompletedCustomers(customers);

          // Update Status Counts based on internal data
          const counts = {
            active: customers.filter((c) => (c.accountStatus || "Active") === "Active").length,
            expired: customers.filter((c) => c.accountStatus === "Expired").length,
            suspended: customers.filter((c) => c.accountStatus === "Suspended").length,
            disabled: customers.filter((c) => c.accountStatus === "Disable").length,
            online: 0,
            offline: 0,
          };
          setStatusCounts(counts);
        }
      })
      .catch((err) => {
        console.error("Error fetching completed customers:", err);
      });
  };

  useEffect(() => {
    fetchCompletedCustomers();
  }, [apiUrl]);

  // Keep old view API for other data if needed, but stats now come from installations
  useEffect(() => {
    axios.post(apiUrl + "view", {}).then((res) => {
      setData(res.data.message || []);
    });
  }, [apiUrl]);

  const handleInstallFilterChange = (e) => {
    const { name, value } = e.target;
    setInstallFilters((prev) => ({ ...prev, [name]: value.toLowerCase() }));
  };

  const filteredInstallCustomers = installCompletedCustomers.filter((c) => {
    const fv = installFilters;
    const matchStr = (field, val) =>
      String(field || "").toLowerCase().includes(val);
    // For customerid filter, match against the number extracted from leadId
    const leadNum = c.leadId ? c.leadId.split("-").pop().trim() : "";
    return (
      (!fv.customerid || matchStr(leadNum, fv.customerid)) &&
      (!fv.installcustomerName || matchStr(c.installcustomerName, fv.installcustomerName)) &&
      (!fv.accountStatus || matchStr(c.accountStatus || "Active", fv.accountStatus)) &&
      (!fv.installcontactNum || matchStr(c.installcontactNum, fv.installcontactNum)) &&
      (!fv.installalternateNum || matchStr(c.installalternateNum, fv.installalternateNum)) &&
      (!fv.installemailId || matchStr(c.installemailId, fv.installemailId)) &&
      (!fv.installleadSource || matchStr(c.installleadSource, fv.installleadSource)) &&
      (!fv.installaddress || matchStr(c.installaddress, fv.installaddress)) &&
      (!fv.installplanSpeed || matchStr(c.installplanDetails?.installplanSpeed, fv.installplanSpeed)) &&
      (!fv.installplanAmount || matchStr(c.installplanDetails?.installplanAmount, fv.installplanAmount)) &&
      (!fv.installplanMonth || matchStr(c.installplanDetails?.installplanMonth, fv.installplanMonth)) &&
      (!fv.createdDate || matchStr(c.createdDate, fv.createdDate))
    );
  });

  const handleEditClick = (customer) => {
    setSelectedCustomer(customer);
    setEditFormData({
      installcustomerName: customer.installcustomerName || "",
      installcontactNum: customer.installcontactNum || "",
      installalternateNum: customer.installalternateNum || "",
      installemailId: customer.installemailId || "",
      installaddress: customer.installaddress || "",
      accountStatus: customer.accountStatus || "Active",
    });
    setShowEditModal(true);
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleUpdateCustomer = async () => {
    try {
      const res = await axios.put(
        `${apiUrl}update-customer/${selectedCustomer._id}`,
        editFormData
      );
      if (res.data.success) {
        toast.success("Customer updated successfully!");
        setShowEditModal(false);
        fetchCompletedCustomers(); // Refresh the list
      } else {
        toast.error("Failed to update customer.");
      }
    } catch (error) {
      console.error("Error updating customer:", error);
      toast.error("An error occurred during update.");
    }
  };

  const handleAddCustomer = async () => {
    try {
      const res = await axios.post(`${apiUrl}add-direct-customer`, addFormData);
      if (res.data.success) {
        toast.success("Customer added successfully!");
        setShowAddModal(false);
        setAddFormData({
          installcustomerName: "",
          installcontactNum: "",
          installalternateNum: "",
          installemailId: "",
          installaddress: "",
          installleadSource: "Manual Entry",
          accountStatus: "Active",
          installplanDetails: {
            installplanSpeed: "",
            installplanAmount: "",
            installplanMonth: "",
          },
          createdDate: new Date().toISOString().split("T")[0],
          activationDate: new Date().toISOString().split("T")[0],
        });
        fetchCompletedCustomers();
      }
    } catch (error) {
      console.error("Error adding customer:", error);
      toast.error("An error occurred.");
    }
  };

  const handleImportExcel = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);

    try {
      const res = await axios.post(`${apiUrl}import-customers`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (res.data.success) {
        toast.success(res.data.message);
        fetchCompletedCustomers();
      }
    } catch (error) {
      console.error("Error importing customers:", error);
      toast.error("Import failed. Check file format.");
    } finally {
      e.target.value = ""; // Reset input
    }
  };

  const downloadSampleExcel = () => {
    const headers = [
      "Customer Name",
      "Account Status",
      "Contact Number",
      "Email ID",
      "Address",
      "Lead Source",
      "Plan Speed",
      "Plan Amount",
      "Plan Months",
      "Created Date",
      "Activation Date",
    ];
    const sampleData = [
      {
        "Customer Name": "John Doe",
        "Account Status": "Active",
        "Contact Number": "9876543210",
        "Email ID": "john@example.com",
        "Address": "123 Main St, City",
        "Lead Source": "Manual",
        "Plan Speed": "40 Mbps",
        "Plan Amount": 500,
        "Plan Months": 1,
        "Created Date": new Date().toISOString().split("T")[0],
        "Activation Date": new Date().toISOString().split("T")[0],
      },
    ];

    const worksheet = XLSX.utils.json_to_sheet(sampleData, { header: headers });
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "SampleData");
    XLSX.writeFile(workbook, "Customer_Import_Sample.xlsx");
  };


  // const fetchData = async () => {
  //   try {
  //     const response = await axios.get(`${apiUrl}refresh-customers-data`);
  //     if (response.status === 200) {
  //       // Fetch the updated customer data
  //       axios.post(apiUrl + "view", {}).then((res) => {
  //         const customers = res.data.message || [];
  //         setData(customers);

  //         const counts = {
  //           active: customers.filter((c) => c.accountstatus === "Active")
  //             .length,
  //           expired: customers.filter((c) => c.accountstatus === "Expired")
  //             .length,
  //           suspended: customers.filter((c) => c.accountstatus === "Suspended")
  //             .length,
  //           disabled: customers.filter((c) => c.accountstatus === "Disabled")
  //             .length,
  //           online: customers.filter((c) => c.devicestatus === "Online").length,
  //           offline: customers.filter((c) => c.devicestatus === "Offline")
  //             .length,
  //         };
  //         setStatusCounts(counts);
  //       });

  //       toast.success("Customer data refreshed successfully!");
  //     } else {
  //       toast.error("Failed to refresh customer data.");
  //     }
  //   } catch (error) {
  //     toast.error("An error occurred while refreshing customer data.");
  //   }
  // };

  const initializeData = async () => {
    try {
      // Call refresh-customers-data API first
      const response = await axios.get(`${apiUrl}refresh-customers-data`);
      if (response.status === 200) {
        toast.success("Customer data refreshed successfully!");
      } else {
        toast.error("Failed to refresh customer data.");
      }
    } catch (error) {
      toast.error("An error occurred while refreshing customer data.");
    } finally {
      // Call the view API regardless of the outcome
      axios.post(apiUrl + "view", {}).then((res) => {
        const customers = res.data.message || [];
        setData(customers);

        const counts = {
          active: customers.filter((c) => c.accountstatus === "Active").length,
          expired: customers.filter((c) => c.accountstatus === "Expired")
            .length,
          suspended: customers.filter((c) => c.accountstatus === "Suspended")
            .length,
          disabled: customers.filter((c) => c.accountstatus === "Disabled")
            .length,
          online: customers.filter((c) => c.devicestatus === "ONLINE").length,
          offline: customers.filter((c) => c.devicestatus === "OFFLINE").length,
        };
        setStatusCounts(counts);
      });
    }
  };

  // Button click handler
  // const refreshCustomer = () => {
  //   Swal.fire({
  //     title: "Do you want to refresh your customer data?",
  //     icon: "question",
  //     showCancelButton: true,
  //     confirmButtonText: "Yes",
  //     cancelButtonText: "No",
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       fetchData();
  //     }
  //   });
  // };

  const [setting, setSetting] = useState(false);

  const settingPopup = (e) => {
    e.preventDefault();
    setSetting(!setting);
  };

  const handleColumnVisibilityChange = (e) => {
    const { name, checked } = e.target;
    setColumnVisibility((prev) => ({ ...prev, [name]: checked }));
  };

  const changedata = (key) => {
    const map = {
      customerId: "Customer ID",
      installcustomerName: "Customer Name",
      accountStatus: "Account Status",
      installcontactNum: "Contact Number",
      installalternateNum: "Alternate Number",
      installemailId: "Email ID",
      installleadSource: "Lead Source",
      installaddress: "Address",
      installplanSpeed: "Plan Speed",
      installplanAmount: "Plan Amount",
      installplanMonth: "Plan Months",
      createdDate: "Created Date",
      activationDate: "Activation Date",
      expiryDate: "Expiry Date",
      actions: "Actions",
    };
    return map[key] || key;
  };

  return (
    <div className="customer-scroll-stop">
      <Topbar />
      <Container fluid className="pt-1 customer-row">
        <h3 className="px-2 text-start">Customers</h3>
        {permissions?.Customer?.["Customer Statistics"]?.Read && (
          <Row className=" row-width">
            <Col className="dashborder mt-4   mb-5 mx-2 ">
              <Row className="purple-card">
                <p
                  className="text-center box-txt "
                  style={{ marginTop: "15px" }}
                >
                  Total Customers
                </p>
              </Row>
              <Row className="number">
                <h5 className="text-center pt-2">{installCompletedCustomers.length}</h5>
              </Row>
            </Col>
            <Col className="dashborder mt-4 mb-5 mx-1  ">
              <Row className="green-card">
                <p className="text-center  box-txt">Active</p>
              </Row>
              <Row className="number">
                <h5 className="text-center pt-1 ">{statusCounts.active}</h5>
              </Row>
            </Col>
            <Col className="dashborder mt-4 mb-5  mx-1">
              <Row className="grey-card ">
                <p className="text-center  box-txt">Expeired</p>
              </Row>
              <Row className="number">
                <h5 className="text-center pt-1">{statusCounts.expired}</h5>
              </Row>
            </Col>
            <Col className="dashborder mt-4 mb-5 mx-1">
              <Row className="yellow-card row-margin">
                <p className="text-center  box-txt">Online</p>
              </Row>
              <Row className="number">
                <h5 className="text-center pt-1">{statusCounts.online}</h5>
              </Row>
            </Col>
            <Col className="dashborder mt-4 mb-5 mx-1">
              <Row className="blue-card">
                <p className="text-center  box-txt">Offline</p>
              </Row>
              <Row className="number">
                <h5 className="text-center pt-1">{statusCounts.offline}</h5>
              </Row>
            </Col>
            <Col className="dashborder mt-4 mb-5 mx-1">
              <Row className="brown-card">
                <p className="text-center  px-1 box-txt">Suspended</p>
              </Row>
              <Row className="number">
                <h5 className="text-center pt-1">{statusCounts.suspended}</h5>
              </Row>{" "}
            </Col>
            <Col className="dashborder mx-1  mt-4 mb-5">
              <Row className="red-card">
                <p className="text-center  box-txt">Disable</p>
              </Row>
              <Row className="number">
                <h5 className="text-center pt-1">{statusCounts.disabled}</h5>
              </Row>
            </Col>
          </Row>
        )}

        <Row className="button-bottom-custmer" xs={1} sm={2}>
          <Col className="mt-2 mb-2 ms-0 d-flex gap-2 align-items-center flex-wrap">
            <button
              onClick={() => initializeData()}
              className="black-btn"
              style={{ minWidth: "120px" }}
            >
              Refresh
            </button>
            <button
              onClick={() => setShowAddModal(true)}
              className="black-btn"
              style={{ backgroundColor: "#28a745", minWidth: "140px" }}
            >
              Add Customer
            </button>
            <button
              onClick={() => setShowImportModal(true)}
              className="black-btn"
              style={{ backgroundColor: "#17a2b8", minWidth: "140px" }}
            >
              📥 Import (Excel)
            </button>
          </Col>

          <Col className="mt-2 text-end">
            {/* <button
              className="black-btn black-btn1"
              onClick={handleExportConfirmation}
            >
              Export
            </button> */}
            &emsp;&emsp;
            {permissions?.Customer?.["Customer Module"]?.Write && (
              <button onClick={settingPopup} className="black-btn black-btn1">
                Settings
              </button>
            )}
          </Col>
        </Row>

        {setting && (
          <div className="setting-popup-overlay">
            <div className="setting-popup-container">
              <button className="setting-close-btn" onClick={settingPopup}>
                &times;
              </button>
              <div className="setting-popup-content">

                    <div className="setting-checkbox-row">
                      <label>
                        <input
                          className="checkbox-customer"
                          type="checkbox"
                          checked={Object.values(columnVisibility).every(
                            (v) => v
                          )}
                          onChange={(e) => {
                            const isChecked = e.target.checked;
                            setColumnVisibility(
                              Object.keys(columnVisibility).reduce(
                                (acc, key) => {
                                  acc[key] = isChecked;
                                  return acc;
                                },
                                {}
                              )
                            );
                          }}
                        />
                        <span
                          className="checkbox-down ms-1"
                          style={{ fontSize: "17px" }}
                        >
                          {Object.values(columnVisibility).every((v) => v)
                            ? "Unselect All"
                            : "Select All"}
                        </span>
                      </label>
                    </div>

                    <div className="setting-checkbox-grid">
                      {Object.keys(columnVisibility).map((key) => (
                        <label key={key} className="label-setting-popup">
                          <input
                            type="checkbox"
                            name={key}
                            checked={columnVisibility[key]}
                            onChange={handleColumnVisibilityChange}
                            className="checbox-popup"
                          />
                          <span className="checkbox-down1">
                            {changedata(key)}
                          </span>
                        </label>
                      ))}
                    </div>

                    <button
                      className="setting-submit-btn"
                      onClick={settingPopup}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
             )}
 
         <br />

        {permissions?.Customer?.["Customer Module"]?.Read && (
          <div className="scrolltable">
            <table className="table table-bordered">
              <thead className="table-th text-center">
                <tr>
                  {columnVisibility.customerId && <th className="table-th-content">Customer ID</th>}
                  {columnVisibility.installcustomerName && <th className="table-th-content">Customer Name</th>}
                  {columnVisibility.accountStatus && <th className="table-th-content">Account Status</th>}
                  {columnVisibility.installcontactNum && <th className="table-th-content">Contact Number</th>}
                  {columnVisibility.installalternateNum && <th className="table-th-content">Alternate Number</th>}
                  {columnVisibility.installemailId && <th className="table-th-content">Email ID</th>}
                  {columnVisibility.installleadSource && <th className="table-th-content">Lead Source</th>}
                  {columnVisibility.installaddress && <th className="table-th-content">Address</th>}
                  {columnVisibility.installplanSpeed && <th className="table-th-content">Plan Speed</th>}
                  {columnVisibility.installplanAmount && <th className="table-th-content">Plan Amount</th>}
                  {columnVisibility.installplanMonth && <th className="table-th-content">Plan Months</th>}
                  {columnVisibility.createdDate && <th className="table-th-content">Created Date</th>}
                  {columnVisibility.activationDate && <th className="table-th-content">Activation Date</th>}
                  {columnVisibility.expiryDate && <th className="table-th-content">Expiry Date</th>}
                  {columnVisibility.actions && <th className="table-th-content">Actions</th>}
                </tr>
              </thead>
              <tbody>
                <tr>
                  {columnVisibility.customerId && <td><input className="table-search background-change" name="customerId" placeholder="Search" onChange={handleInstallFilterChange} /></td>}
                  {columnVisibility.installcustomerName && <td><input className="table-search background-change" name="installcustomerName" placeholder="Search" onChange={handleInstallFilterChange} /></td>}
                  {columnVisibility.accountStatus && (
                    <td>
                      <select className="table-search background-change" name="accountStatus" onChange={handleInstallFilterChange}>
                        <option value="">All</option>
                        <option value="active">Active</option>
                        <option value="expired">Expired</option>
                        <option value="suspended">Suspended</option>
                        <option value="disable">Disable</option>
                      </select>
                    </td>
                  )}
                  {columnVisibility.installcontactNum && (
                    <td><input className="table-search background-change" name="installcontactNum" placeholder="Search" type="tel"
                      onKeyDown={(e) => { if (["e","E","+","-"].includes(e.key)||(e.key&&!/[0-9]/.test(e.key)&&e.key!=="Backspace"&&e.key!=="ArrowLeft"&&e.key!=="ArrowRight")) e.preventDefault(); }}
                      onChange={handleInstallFilterChange} /></td>
                  )}
                  {columnVisibility.installalternateNum && (
                    <td><input className="table-search background-change" name="installalternateNum" placeholder="Search" type="tel"
                      onKeyDown={(e) => { if (["e","E","+","-"].includes(e.key)||(e.key&&!/[0-9]/.test(e.key)&&e.key!=="Backspace"&&e.key!=="ArrowLeft"&&e.key!=="ArrowRight")) e.preventDefault(); }}
                      onChange={handleInstallFilterChange} /></td>
                  )}
                  {columnVisibility.installemailId && <td><input className="table-search background-change" name="installemailId" placeholder="Search" onChange={handleInstallFilterChange} /></td>}
                  {columnVisibility.installleadSource && <td><input className="table-search background-change" name="installleadSource" placeholder="Search" onChange={handleInstallFilterChange} /></td>}
                  {columnVisibility.installaddress && <td><input className="table-search background-change" name="installaddress" placeholder="Search" onChange={handleInstallFilterChange} /></td>}
                  {columnVisibility.installplanSpeed && <td><input className="table-search background-change" name="installplanSpeed" placeholder="Search" onChange={handleInstallFilterChange} /></td>}
                  {columnVisibility.installplanAmount && <td><input className="table-search background-change" name="installplanAmount" placeholder="Search" onChange={handleInstallFilterChange} /></td>}
                  {columnVisibility.installplanMonth && <td><input className="table-search background-change" name="installplanMonth" placeholder="Search" onChange={handleInstallFilterChange} /></td>}
                  {columnVisibility.createdDate && <td><input className="table-search background-change" name="createdDate" type="date" onChange={handleInstallFilterChange} /></td>}
                  {columnVisibility.activationDate && <td><input className="table-search background-change" name="activationDate" type="date" onChange={handleInstallFilterChange} /></td>}
                  {columnVisibility.expiryDate && <td><input className="table-search background-change" name="expiryDate" type="date" onChange={handleInstallFilterChange} /></td>}
                  {columnVisibility.actions && <td></td>}
                </tr>

                {filteredInstallCustomers.length === 0 ? (
                  <tr><td colSpan="12" style={{ textAlign: "center" }}>No completed installation customers found</td></tr>
                ) : (
                  filteredInstallCustomers.map((c, i) => (
                    <tr key={i}>
                      {columnVisibility.customerId && <td>{c.customerId || "-"}</td>}
                      {columnVisibility.installcustomerName && <td style={{ textTransform: "capitalize" }}>{c.installcustomerName || "-"}</td>}
                      {columnVisibility.accountStatus && (
                        <td>
                          <span className={`status-${(c.accountStatus || "Active").toLowerCase()}`}>
                            {c.accountStatus || "Active"}
                          </span>
                        </td>
                      )}
                      {columnVisibility.installcontactNum && <td>{c.installcontactNum || "-"}</td>}
                      {columnVisibility.installalternateNum && <td>{c.installalternateNum || "-"}</td>}
                      {columnVisibility.installemailId && <td>{c.installemailId || "-"}</td>}
                      {columnVisibility.installleadSource && <td style={{ textTransform: "capitalize" }}>{c.installleadSource || "-"}</td>}
                      {columnVisibility.installaddress && <td style={{ textTransform: "capitalize" }}>{c.installaddress || "-"}</td>}
                      {columnVisibility.installplanSpeed && <td>{c.installplanDetails?.installplanSpeed ? c.installplanDetails.installplanSpeed + " Mbps" : "-"}</td>}
                      {columnVisibility.installplanAmount && <td>{c.installplanDetails?.installplanAmount ? "₹" + c.installplanDetails.installplanAmount : "-"}</td>}
                      {columnVisibility.installplanMonth && <td>{c.installplanDetails?.installplanMonth ? c.installplanDetails.installplanMonth + " Mo" : "-"}</td>}
                      {columnVisibility.createdDate && <td>{c.createdDate ? new Date(c.createdDate).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "-"}</td>}
                      {columnVisibility.activationDate && <td>{c.activationDate ? new Date(c.activationDate).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "-"}</td>}
                      {columnVisibility.expiryDate && (
                        <td>
                          <span style={{ color: c.expiryDate && new Date(c.expiryDate) < new Date() ? "red" : "inherit", fontWeight: c.expiryDate && new Date(c.expiryDate) < new Date() ? "bold" : "normal" }}>
                            {c.expiryDate ? new Date(c.expiryDate).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "-"}
                          </span>
                        </td>
                      )}
                      {columnVisibility.actions && (
                        <td className="text-center">
                          <button
                            className="btn btn-sm btn-outline-primary"
                            onClick={() => handleEditClick(c)}
                            title="Edit Customer"
                          >
                            <FaEdit />
                          </button>
                        </td>
                      )}
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        )}

        <ToastContainer />

        {/* ── Edit Customer Modal ── */}
        <Modal show={showEditModal} onHide={() => setShowEditModal(false)} centered backdrop="static">
          <Modal.Header closeButton className="bg-primary text-white">
            <Modal.Title>Edit Customer Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Customer Name</Form.Label>
                <Form.Control
                  type="text"
                  name="installcustomerName"
                  value={editFormData.installcustomerName}
                  onChange={handleEditChange}
                />
              </Form.Group>
              <Row>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label>Contact Number</Form.Label>
                    <Form.Control
                      type="text"
                      name="installcontactNum"
                      value={editFormData.installcontactNum}
                      onChange={handleEditChange}
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label>Alternate Number</Form.Label>
                    <Form.Control
                      type="text"
                      name="installalternateNum"
                      value={editFormData.installalternateNum}
                      onChange={handleEditChange}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Form.Group className="mb-3">
                <Form.Label>Email ID</Form.Label>
                <Form.Control
                  type="email"
                  name="installemailId"
                  value={editFormData.installemailId}
                  onChange={handleEditChange}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Address</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  name="installaddress"
                  value={editFormData.installaddress}
                  onChange={handleEditChange}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Account Status</Form.Label>
                <Form.Select
                  name="accountStatus"
                  value={editFormData.accountStatus}
                  onChange={handleEditChange}
                >
                  <option value="Active">Active</option>
                  <option value="Expired">Expired</option>
                  <option value="Suspended">Suspended</option>
                  <option value="Disable">Disable</option>
                </Form.Select>
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowEditModal(false)}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleUpdateCustomer}>
              Update Customer
            </Button>
          </Modal.Footer>
        </Modal>

        {/* ── Add Customer Modal ── */}
        <Modal show={showAddModal} onHide={() => setShowAddModal(false)} centered backdrop="static">
          <Modal.Header closeButton className="bg-success text-white">
            <Modal.Title>Add New Customer</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Customer Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Name"
                  value={addFormData.installcustomerName}
                  onChange={(e) => setAddFormData({ ...addFormData, installcustomerName: e.target.value })}
                />
              </Form.Group>
              <Row>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label>Contact Number</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Contact"
                      value={addFormData.installcontactNum}
                      onChange={(e) => setAddFormData({ ...addFormData, installcontactNum: e.target.value })}
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label>Alternate Number</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Alternate"
                      value={addFormData.installalternateNum}
                      onChange={(e) => setAddFormData({ ...addFormData, installalternateNum: e.target.value })}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Form.Group className="mb-3">
                <Form.Label>Email ID</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Email"
                  value={addFormData.installemailId}
                  onChange={(e) => setAddFormData({ ...addFormData, installemailId: e.target.value })}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Address</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  placeholder="Full Address"
                  value={addFormData.installaddress}
                  onChange={(e) => setAddFormData({ ...addFormData, installaddress: e.target.value })}
                />
              </Form.Group>
              <Row>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label>Account Status</Form.Label>
                    <Form.Select
                      value={addFormData.accountStatus}
                      onChange={(e) => setAddFormData({ ...addFormData, accountStatus: e.target.value })}
                    >
                      <option value="Active">Active</option>
                      <option value="Expired">Expired</option>
                      <option value="Suspended">Suspended</option>
                      <option value="Disable">Disable</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label>Lead Source</Form.Label>
                    <Form.Control
                      type="text"
                      value={addFormData.installleadSource}
                      onChange={(e) => setAddFormData({ ...addFormData, installleadSource: e.target.value })}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <hr />
              <h6>Plan Details</h6>
              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Plan Speed (Mbps)</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="e.g. 40"
                      value={addFormData.installplanDetails.installplanSpeed}
                      onChange={(e) => setAddFormData({ 
                        ...addFormData, 
                        installplanDetails: { ...addFormData.installplanDetails, installplanSpeed: e.target.value } 
                      })}
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Plan Amount</Form.Label>
                    <Form.Control
                      type="number"
                      placeholder="Amount"
                      value={addFormData.installplanDetails.installplanAmount}
                      onChange={(e) => setAddFormData({ 
                        ...addFormData, 
                        installplanDetails: { ...addFormData.installplanDetails, installplanAmount: e.target.value } 
                      })}
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Plan Months</Form.Label>
                    <Form.Control
                      type="number"
                      placeholder="Months"
                      value={addFormData.installplanDetails.installplanMonth}
                      onChange={(e) => setAddFormData({ 
                        ...addFormData, 
                        installplanDetails: { ...addFormData.installplanDetails, installplanMonth: e.target.value } 
                      })}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label>Created Date</Form.Label>
                    <Form.Control
                      type="date"
                      value={addFormData.createdDate}
                      onChange={(e) => setAddFormData({ ...addFormData, createdDate: e.target.value })}
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label>Activation Date</Form.Label>
                    <Form.Control
                      type="date"
                      value={addFormData.activationDate}
                      onChange={(e) => setAddFormData({ ...addFormData, activationDate: e.target.value })}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowAddModal(false)}>
              Cancel
            </Button>
            <Button variant="success" onClick={handleAddCustomer}>
              Create Customer
            </Button>
          </Modal.Footer>
        </Modal>

        {/* ── Import Customer Modal ── */}
        <Modal show={showImportModal} onHide={() => setShowImportModal(false)} centered>
          <Modal.Header closeButton className="bg-info text-white">
            <Modal.Title>Import Customers from Excel</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="p-3 text-center">
              <div className="mb-4">
                <h6>Step 1: Download Template</h6>
                <p className="text-muted small">Click the button below to download the sample Excel format.</p>
                <Button 
                  variant="outline-primary" 
                  onClick={downloadSampleExcel}
                  className="d-flex align-items-center justify-content-center mx-auto"
                >
                  <FaDownload className="me-2" /> Download Sample Excel
                </Button>
              </div>

              <hr />

              <div className="mt-4 p-4 border rounded bg-light">
                <h6>Step 2: Upload Filled File</h6>
                <p className="text-muted small">Fill the data in the downloaded file and upload it here.</p>
                <input
                  type="file"
                  ref={fileInputRef}
                  style={{ display: "none" }}
                  accept=".xlsx, .xls"
                  onChange={(e) => {
                    handleImportExcel(e);
                    setShowImportModal(false);
                  }}
                />
                <Button 
                  variant="success" 
                  size="lg" 
                  onClick={() => fileInputRef.current.click()}
                  className="mt-2"
                >
                  📁 Select & Upload Excel
                </Button>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowImportModal(false)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    </div>
  );
}
